import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import { red } from '@mui/material/colors';

class ReprovacaoDocumentoSustentacaoOralDialog extends ReactComponent {
    motivoReprovacao = '';
    erroMotivoReprovacao = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            motivoReprovacao: observable,
            erroMotivoReprovacao: observable,
            handleAlteraMotivoCancelamento: action,
            reprovarDocumento: action
        });
    }

    handleAlteraMotivoCancelamento = (e) => {
        const motivoReprovacao = e.target.value;
        this.motivoReprovacao = motivoReprovacao;
        if (motivoReprovacao !== '') this.erroMotivoReprovacao = '';
    };

    reprovarDocumento = async () => {
        if (this.motivoReprovacao === '') {
            this.erroMotivoReprovacao = 'Informe o motivo da reprovação do documento.';
        } else {
            this.observableProps.onReprovarDocumento(this.motivoReprovacao);
        }
    };

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.observableProps.handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DialogTitle id="alert-dialog-title">Reprovação de documento</DialogTitle>
                </Box>
                <DialogContent sx={{ minWidth: '500px' }}>
                    <TextField
                        label="Motivo da reprovação do documento"
                        variant="filled"
                        multiline
                        minRows={4}
                        fullWidth
                        onChange={this.handleAlteraMotivoCancelamento}
                        value={this.motivoReprovacao}
                        error={this.erroMotivoReprovacao !== ''}
                        slotProps={{
                            inputLabel: {
                                shrink: true
                            }
                        }}
                    />
                    {this.erroMotivoReprovacao && (
                        <Typography
                            color={red[500]}
                            sx={{ mt: 1, fontSize: 12 }}
                        >
                            {this.erroMotivoReprovacao}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', mx: 2, my: 2 }}>
                    <Button
                        color="secondary"
                        onClick={this.observableProps.onClose}
                        variant="outlined"
                        data-testid="closeDialog"
                        endIcon={<Cancel />}
                    >
                        Fechar
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        endIcon={<Save />}
                        onClick={this.reprovarDocumento}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ReprovacaoDocumentoSustentacaoOralDialog));
